module.exports = __webpack_public_path__ + "static/media/CV.8494021b.pdf";